import React, { useState, useEffect, useRef } from 'react';

const AnimatedNumber = ({ value, suffix = '+', duration = 1500 }) => {
  const [displayValue, setDisplayValue] = useState(0);
  const prevTarget = useRef(0);
  const frameRef = useRef(null);

  useEffect(() => {
    if (value == null) return;

    const start = prevTarget.current;
    const end = value;
    const startTime = performance.now();

    const step = (currentTime) => {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      const current = Math.round(start + (end - start) * eased);

      setDisplayValue(current);

      if (progress < 1) {
        frameRef.current = requestAnimationFrame(step);
      } else {
        prevTarget.current = end;
      }
    };

    frameRef.current = requestAnimationFrame(step);

    return () => {
      if (frameRef.current) {
        cancelAnimationFrame(frameRef.current);
      }
    };
  }, [value, duration]);

  if (value == null) return null;

  return <>{displayValue}{suffix}</>;
};

export default AnimatedNumber;
